import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingApprove from "../BookingApprove";

const BookingApproved = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Booking List" />
      <BookingApprove status={1}/>
    </MasterLayout>
  );
};

export default BookingApproved;
